import React from "react";

const Errors = (props) => {
    const { msg, errorClass } = props;
    if(msg === '') {
    } else {
        return (
            <div class={errorClass}>
                {msg}
            </div>
        );
    }
};
export default Errors;